exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:block}:host audio{display:none}:host a{margin-bottom:.3rem}:host .form-group{margin-top:.2rem}:host img{margin-left:auto;margin-right:auto;display:block}:host .btn-circle{display:flex;align-items:center;justify-content:center;background:#fff;width:2rem;height:2rem;margin:.5rem 0}:host .btn-circle:hover{color:#fff;background:#005092}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/shared/components/captcha/captcha.component.scss
// module id = 724
// module chunks = 0